<template>
    <div>
        <tabs></tabs>
    </div>
</template>

<script>
import {Message} from "element-ui"
import tabs from '@/components/tab'
export default {
    components:{
        tabs,
    },
    name:"home",
    data(){
        return{
            
        }
    },
    methods:{

    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/home.vue